import { create } from "zustand";
import {
  createPoiFilterState,
  type PoiFilterState,
} from "../hooks/usePoiFilters";

/**
 * Filter state for the trip sidebar, hosted outside the component tree so it
 * survives the remount that happens when the user switches between the
 * calendar and map views. Scope and map-bounds filtering stay local to each
 * view because their defaults are view-specific.
 */
interface TripSidebarFilterStore {
  filters: PoiFilterState;
  hideScheduled: boolean;
  updateFilters: (
    updater: (prev: PoiFilterState) => Partial<PoiFilterState>,
  ) => void;
  setHideScheduled: (value: boolean) => void;
  /** Reset when leaving a trip so filters do not leak into the next one. */
  resetFilters: () => void;
}

export const useTripSidebarFilterStore = create<TripSidebarFilterStore>(
  (set) => ({
    filters: createPoiFilterState(),
    hideScheduled: false,
    updateFilters: (updater) =>
      set((s) => ({ filters: { ...s.filters, ...updater(s.filters) } })),
    setHideScheduled: (hideScheduled) => set({ hideScheduled }),
    resetFilters: () =>
      set({ filters: createPoiFilterState(), hideScheduled: false }),
  }),
);
